import meter1 from "../../assets/img/meter1.svg";
import meter2 from "../../assets/img/meter2.svg";
import meter3 from "../../assets/img/meter3.svg";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import colorSharp from "../../assets/img/color-sharp.png";
import "./Skills.styles.css";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Skills</h2>
              <p>
                Completed 9 projects with javaScript and reactJs.<br></br> Also
                have good Communication skills, great in Teamwork and
                Adaptability.
              </p>
              <Carousel
                responsive={responsive}
                infinite={true}
                className="owl-carousel owl-theme skill-slider"
              >
                <div className="item">
                  {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                  <img src={meter1} alt="Image" />
                  <h5>ReactJs</h5>
                </div>
                <div className="item">
                  {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                  <img src={meter2} alt="Image" />
                  <h5>CSS3</h5>
                </div>
                <div className="item">
                  {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                  <img src={meter3} alt="Image" />
                  <h5>HTML5</h5>
                </div>
                <div className="item">
                  {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                  <img src={meter1} alt="Image" />
                  <h5>JavaScript</h5>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
      <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  );
};
